module.exports = __webpack_public_path__ + "static/img/hero_preview.1867e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/hero_preview.png
// module id = WMNe
// module chunks = 0